import { useContext } from "react";

import { previewAndDownloadDeclarationFile } from "../../../../adapters/apis/UnifiedTaxDeclaration/details";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import InputElement from "../../../../shared/form/InputElement";
import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";

const UserAndTaxPayerDetailFiles = ({ user }) => {
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const { declarationRequest } = unifiedTaxDeclarationContext;

  const handlePreviewFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclarationFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handleDownloadFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclarationFile(url);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      // Extract filename from Content-Disposition header
      let fileName = "file"; // Default filename
      let originFileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="(.+?)"/);
        if (match) {
          originFileName = match[1];
        }
      }

      const mimeType = blob.type;
      const ext = originFileName.split(".").pop().toLowerCase();

      if (ext === "jfif" || mimeType === "image/jfif") {
        fileName = "file.jfif";
      } else if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
        fileName = ext === "jpg" ? "file.jpg" : "file.jpeg";
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName.replace(/"/g, ""); // Remove any quotes
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };
  return (
    <>
      <h4 className={`mb-4 fw-semibold`} style={{ color: "#32A8ED" }}>
        بيانات مقدم الإقرار{" "}
      </h4>
      {declarationRequest?.applicant?.profile?.national_id_file[0] &&
        declarationRequest?.applicant?.profile?.national_id_file[0]?.url && (
          <div className="col-md-4">
            <InputElement
              value={
                declarationRequest?.applicant?.profile?.national_id_file[0]
                  ?.original_file_name || "الملف"
              }
              disabled={true}
              name="national_id_file"
              mb4="mb-4"
              labelHtmlFor="national_id_file"
              labelClassName={` ${stylesRequestData["form-label"]} form-label`}
              labelText="صورة الرقم القومي لمقدم الإقرار"
              inputType="text"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="national_id_file_input"
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              isIcon={
                declarationRequest?.applicant?.profile?.national_id_file[0]
                  ?.url ?? ""
              }
              style={{ paddingLeft: "70px" }}
              idDownload={declarationRequest?.applicant?.profile?.id}
              declarationId={declarationRequest?.id}
              filedDownload="nationalIdFile"
            />
          </div>
        )}

      {declarationRequest?.applicant?.profile?.passport_num_file[0] &&
        declarationRequest?.applicant?.profile?.passport_num_file[0]?.url && (
          <div className="col-md-4">
            <InputElement
              value={
                declarationRequest?.applicant?.profile?.passport_num_file[0]
                  ?.original_file_name || "الملف"
              }
              disabled={true}
              name="passport_number_file"
              mb4="mb-4"
              labelHtmlFor="passport_number_file"
              labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
              labelText="صورة جواز السفر لمقدم الإقرار"
              inputType="text"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="passport_number_file_input"
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              isIcon={
                declarationRequest?.applicant?.profile?.passport_num_file[0]
                  ?.url ?? ""
              }
              style={{ paddingLeft: "70px" }}
              idDownload={declarationRequest?.applicant?.profile?.id}
              declarationId={declarationRequest?.id}
              filedDownload="passportNumFile"
            />
          </div>
        )}

      {parseInt(declarationRequest?.applicant_role_id) === 2 && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="joint_ownership_document"
            name="joint_ownership_document"
            labelClassName={`form-label`}
            labelText="صورة سند الملكية على الشيوع / إعلام الوراثة"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="joint_ownership_document_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.joint_ownership_document
                ?.original_file_name ||
              (declarationRequest?.joint_ownership_document ? "الملف" : "")
            }
            isIcon={declarationRequest?.joint_ownership_document || ""}
            disabled={true}
            filedDownload="jointOwnershipDocument"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(
                declarationRequest?.joint_ownership_document?.full_url,
              )
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.joint_ownership_document?.full_url,
              )
            }
          />
        </div>
      )}

      <h4 className={`mb-4 fw-semibold`} style={{ color: "#32A8ED" }}>
        بيانات المكلف بأداء الضريبة{" "}
      </h4>

      {[5, 6, 7].includes(parseInt(declarationRequest?.applicant_role_id)) && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="power_of_attorney"
            name="power_of_attorney"
            labelClassName={`form-label`}
            labelText="صورة سند التوكيل/ سند التمثيل القانوني"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="power_of_attorney_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.power_of_attorney?.original_file_name ||
              (declarationRequest?.power_of_attorney ? "الملف" : "")
            }
            isIcon={declarationRequest?.power_of_attorney || ""}
            disabled={true}
            filedDownload="powerOfAttorney"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(declarationRequest?.power_of_attorney?.full_url)
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.power_of_attorney?.full_url,
              )
            }
          />
        </div>
      )}

      {declarationRequest?.taxpayer?.national_id_attachment && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="national_id_attachment"
            name="national_id_attachment"
            labelClassName={`form-label`}
            labelText="مرفق الرقم القومي"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="national_id_attachment_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.taxpayer?.national_id_attachment
                ?.original_file_name ||
              (declarationRequest?.taxpayer?.national_id_attachment
                ? "الملف"
                : "")
            }
            isIcon={declarationRequest?.taxpayer?.national_id_attachment || ""}
            disabled={true}
            filedDownload="nationalIdAttachment"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(
                declarationRequest?.taxpayer?.national_id_attachment?.full_url,
              )
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.taxpayer?.national_id_attachment?.full_url,
              )
            }
          />
        </div>
      )}

      {declarationRequest?.taxpayer?.passport_attachment && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="passport_attachment"
            name="passport_attachment"
            labelClassName={`form-label`}
            labelText="مرفق جواز  السفر"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="passport_attachment_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.taxpayer?.passport_attachment
                ?.original_file_name ||
              (declarationRequest?.taxpayer?.passport_attachment ? "الملف" : "")
            }
            isIcon={declarationRequest?.taxpayer?.passport_attachment || ""}
            disabled={true}
            filedDownload="passportAttachment"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(
                declarationRequest?.taxpayer?.passport_attachment?.full_url,
              )
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.taxpayer?.passport_attachment?.full_url,
              )
            }
          />
        </div>
      )}

      {declarationRequest?.taxpayer?.commercial_register_attachment && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="commercial_register_attachment"
            name="commercial_register_attachment"
            labelClassName={`form-label`}
            labelText="صورة رقم السجل التجاري"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="commercial_register_attachment_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.taxpayer?.commercial_register_attachment
                ?.original_file_name ||
              (declarationRequest?.taxpayer?.commercial_register_attachment
                ? "الملف"
                : "")
            }
            isIcon={
              declarationRequest?.taxpayer?.commercial_register_attachment || ""
            }
            disabled={true}
            filedDownload="commercialRegisterAttachment"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(
                declarationRequest?.taxpayer?.commercial_register_attachment
                  ?.full_url,
              )
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.taxpayer?.commercial_register_attachment
                  ?.full_url,
              )
            }
          />
        </div>
      )}

      {declarationRequest?.taxpayer?.tax_card_attachment && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="tax_card_attachment"
            name="tax_card_attachment"
            labelClassName={`form-label`}
            labelText="صورة البطاقة الضريبية"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="tax_card_attachment_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.taxpayer?.tax_card_attachment
                ?.original_file_name ||
              (declarationRequest?.taxpayer?.tax_card_attachment ? "الملف" : "")
            }
            isIcon={declarationRequest?.taxpayer?.tax_card_attachment || ""}
            disabled={true}
            filedDownload="taxCardAttachment"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(
                declarationRequest?.taxpayer?.tax_card_attachment?.full_url,
              )
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.taxpayer?.tax_card_attachment?.full_url,
              )
            }
          />
        </div>
      )}

      {declarationRequest?.taxpayer?.other_attachment && (
        <div className="col-md-4">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="other_attachment"
            name="other_attachment"
            labelClassName={`form-label`}
            labelText="المرفق"
            inputType="text"
            inputClassName={`form-control font-grey`}
            inputID="other_attachment_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={
              declarationRequest?.taxpayer?.other_attachment
                ?.original_file_name ||
              (declarationRequest?.taxpayer?.other_attachment ? "الملف" : "")
            }
            isIcon={declarationRequest?.taxpayer?.other_attachment || ""}
            disabled={true}
            filedDownload="otherAttachment"
            serverSide={true}
            style={{ paddingLeft: "70px" }}
            previewFunction={() =>
              handlePreviewFile(
                declarationRequest?.taxpayer?.other_attachment?.full_url,
              )
            }
            downloadFunction={() =>
              handleDownloadFile(
                declarationRequest?.taxpayer?.other_attachment?.full_url,
              )
            }
          />
        </div>
      )}
    </>
  );
};

export default UserAndTaxPayerDetailFiles;
